import React from 'react'

import BackButton from 'components/Button/BackButton'
import PrimaryButton from 'components/Button/PrimaryButton'
import Description from 'components/Description/VerifaiDescription'
import { Icon } from 'components/Image/Icon'
import { SvgWrapperSC } from 'components/Image/Image.style'
import Body from 'components/Screen/Body/VerifaiBody'
import Footer from 'components/Screen/Footer/VerifaiFooter'
import Header from 'components/Screen/Header/VerifaiHeader'
import Heading from 'components/Screen/Heading/Heading'
import Screen from 'components/Screen/Screen'
import { VerifaiMessage } from 'components/Text/VerifaiIntl'
import { Router } from 'typings/context'

interface ScreenWA1Props {
  router: Router
}

function ScreenWA1(props: ScreenWA1Props) {
  const { router } = props

  return (
    <Screen>
      <Heading>
        <Header messageKey="WA1_title" />
      </Heading>

      <Body>
        <Description>
          <VerifaiMessage id="WA1_description" />
        </Description>

        <SvgWrapperSC>
          <Icon id="idImage" isDecorative />
        </SvgWrapperSC>
      </Body>

      <Footer>
        <BackButton />
        <PrimaryButton
          messageId="WA1_button_primary"
          onClick={() => router.next()}
          dataTestId="greeting-continue-btn"
        />
      </Footer>
    </Screen>
  )
}

export default ScreenWA1
